module.exports = __webpack_public_path__ + "img/accessory_hat_04.7bc50ae0.svg";